import { Link } from '../../components/Link.tsx';
import { Hero } from '../../components/marketing/Hero.tsx';
import { MarketingFooter } from '../../components/marketing/MarketingFooter.tsx';
import { useFormatPublishedOn } from '../../components/blog/BlogArticle.tsx';
import { useDocumentTitle } from '../../hooks/useDocumentTitle.ts';
import { useRichT, useT } from '../../i18n.ts';
import { blogPosts, blogPostPath } from './posts.ts';
import '../../styles/marketing.css';

// /blog: every post, newest first, as a dated title and one-line summary.
export function BlogIndex() {
  const t = useT();
  const rt = useRichT();
  const formatDate = useFormatPublishedOn();
  useDocumentTitle(t('blog.index.document-title'));

  return (
    <div className="mkt-page">
      {/* "Goalposts", with "posts" in the accent: the brand's name with the
          section's name picked out of it. It names the page on its own, so no
          eyebrow; the posts and every nav link keep the plain word "Blog". */}
      <Hero
        title={<span className="blog-index-title">{rt('blog.index.title')}</span>}
        lede={t('blog.index.lede')}
      />
      <section className="mkt-section tight blog-index">
        <div className="mkt-container-narrow">
          <ul className="blog-list" data-gp-name="post-list">
            {blogPosts.map(({ meta }) => (
              <li key={meta.slug} className="blog-list-item">
                <p className="blog-list-date">
                  <time dateTime={meta.publishedOn}>{formatDate(meta.publishedOn)}</time>
                </p>
                <h2 className="blog-list-title">
                  <Link to={blogPostPath(meta.slug)}>{t(meta.titleKey)}</Link>
                </h2>
                <p className="blog-list-summary">{t(meta.summaryKey)}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
